import { TenantEntity } from '../TenantEntity'
import { CargoDoc } from './CargoDoc'
import { SeaCargoDoc } from './SeaCargoDoc'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import {
  getSlavesHBLEnglishName,
  getSlavesHBLMark,
  getJointSlavesMBL,
  getJointSlavesHBL,
  getJointSlavesHAWB2,
  getListJobContainerUsages,
  loadJobRelated,
  updateQWCActual,
  getJobByUuid
} from '@/api/booking/job'
import { cargoDocSeaExportSearch, getChargeList, getChargeDetails, getAllSlaveChargeList, getAllSlaveCargoDocList } from '@/api/seaExport/seaExportJob'
import { loadAutoContainerLog } from '@/api/seaExport/subscribePortPushHistory'
import { poItems } from '@/api/seaExport/poItems'
import { poList } from '@/api/seaExport/poList'
import { trucking } from '@/api/seaExport/trucking'
import { getDischargingTruckingList } from '@/api/seaExport/dischargingTrucking'
import { getTruckingInfoPodList } from '@/api/integratedJob/truckingInfoPod'
import { warehouseInfoList, getJobWarehouseNos } from '@/api/seaExport/warehouseInfo'
import { getManifestInfosByJobUuid, getManifestInfoDetailsByJobUuid } from '@/api/seaExport/manifestInfo'
import { containerUsagesByJobUuid } from '@/api/seaExport/containerUsage'
import { containerList } from '@/api/seaExport/container'
import { seaEQList } from '@/api/seaExport/seaEQ'
import {
  updateBusinessDate,
  updateBusinessAdjustment,
  updateChangeState,
  jobAccountVerifyRollback,
  jobClosingAccountRollbackFunc, jobSingleAccountVerifyRollback
} from '@/api/clearing/financeManage'
import { sortByMultiFieldAndOrder } from '@/utils'
import { getOverseaAgentPort } from '@/api/partner/overseaAgentPort'
import { getUsCustomsClearanceDetailList } from '@/api/booking/usCustomsClearance'
import { unitLoadDeviceUsagesByJobUuid } from '@/api/seaExport/unitLoadDeviceUsage'
import { airUldList } from '@/api/seaExport/airUld'
import { unitLoadDeviceList } from '@/api/seaExport/unitLoadDevice'
import * as NumberUtils from '@/utils/NumberUtils'
import StrUtils from '@/utils/StrUtils'

export class Job extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'Job'
  }

  // 非数据库字段
  get printHblZbLock() {
    return this._data.printHblZbLock
  }
  set printHblZbLock(printHblZbLock) {
    this._data.printHblZbLock = printHblZbLock || false
  }
  // 是否有分摊费用
  get hasSharedCharge() {
    return this._data.hasSharedCharge
  }
  set hasSharedCharge(hasSharedCharge) {
    this._data.hasSharedCharge = hasSharedCharge || false
  }
  get fba() { // 是否FBA业务
    return this._data.fba
  }
  set fba(fba) {
    this._data.fba = fba || false
  }
  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo
  }
  get jobNo5() {
    return this._data.jobNo5
  }
  set jobNo5(jobNo5) {
    this._data.jobNo5 = jobNo5
  }
  get warehouseNo() {
    return this._data.warehouseNo
  }
  set warehouseNo(warehouseNo) {
    this._data.warehouseNo = warehouseNo
  }
  get customerRefNo() {
    return this._data.customerRefNo
  }
  set customerRefNo(customerRefNo) {
    this._data.customerRefNo = customerRefNo
  }
  get agentRefNo() {
    return this._data.agentRefNo
  }
  set agentRefNo(agentRefNo) {
    this._data.agentRefNo = agentRefNo
  }
  get mbl() {
    return this._data.mbl
  }
  set mbl(mbl) {
    this._data.mbl = mbl
  }
  get mblNo5() {
    return this._data.mblNo5
  }
  set mblNo5(mblNo5) {
    this._data.mblNo5 = mblNo5
  }
  get jobSoNo() {
    return this._data.jobSoNo
  }
  set jobSoNo(jobSoNo) {
    this._data.jobSoNo = jobSoNo
  }
  get cargoCode() {
    return this._data.cargoCode
  }
  set cargoCode(cargoCode) {
    this._data.cargoCode = cargoCode
  }
  get cargoName() {
    return this._data.cargoName
  }
  set cargoName(cargoName) {
    this._data.cargoName = cargoName
  }
  get relatedJob() {
    return this._data.relatedJob
  }
  set relatedJob(relatedJob) {
    this._data.relatedJob = relatedJob
  }
  get relatedJob2() {
    return this._data.relatedJob2
  }
  set relatedJob2(relatedJob2) {
    this._data.relatedJob2 = relatedJob2
  }
  get mblOnly() {
    return this._data.mblOnly
  }
  set mblOnly(mblOnly) {
    this._data.mblOnly = mblOnly || false
  }
  get joinFlagMBL() {
    return this._data.joinFlagMBL
  }
  set joinFlagMBL(joinFlagMBL) {
    this._data.joinFlagMBL = joinFlagMBL || false
  }
  get joinFlagHBL() {
    return this._data.joinFlagHBL
  }
  set joinFlagHBL(joinFlagHBL) {
    this._data.joinFlagHBL = joinFlagHBL || false
  }

  get joinFlagHAWB2() {
    return this._data.joinFlagHAWB2
  }
  set joinFlagHAWB2(joinFlagHAWB2) {
    this._data.joinFlagHAWB2 = joinFlagHAWB2 || false
  }
  get masterFlag() {
    return this._data.masterFlag
  }
  set masterFlag(masterFlag) {
    this._data.masterFlag = masterFlag || false
  }

  get master() {
    return this._master
  }

  set master(value) {
    this._master = value || {}
  }

  get cancelled() {
    return this._data.cancelled
  }
  set cancelled(cancelled) {
    this._data.cancelled = cancelled || false
  }
  get salesOffice() {
    return this._data.salesOffice
  }
  set salesOffice(salesOffice) {
    this._data.salesOffice = salesOffice || 0
  }
  get salesDepartment() {
    return this._data.salesDepartment
  }
  set salesDepartment(salesDepartment) {
    this._data.salesDepartment = salesDepartment || 0
  }
  get sales() {
    return this._data.sales
  }
  set sales(sales) {
    this._data.sales = sales || 0
  }
  get csrOffice() {
    return this._data.csrOffice
  }
  set csrOffice(csrOffice) {
    this._data.csrOffice = csrOffice || 0
  }
  get csrDepartment() {
    return this._data.csrDepartment
  }
  set csrDepartment(csrDepartment) {
    this._data.csrDepartment = csrDepartment || 0
  }
  get csr() {
    return this._data.csr
  }
  set csr(csr) {
    this._data.csr = csr || 0
  }
  get opOffice() {
    return this._data.opOffice
  }
  set opOffice(opOffice) {
    this._data.opOffice = opOffice || 0
  }
  get opDepartment() {
    return this._data.opDepartment
  }
  set opDepartment(opDepartment) {
    this._data.opDepartment = opDepartment || 0
  }
  get op() {
    return this._data.op
  }
  set op(op) {
    this._data.op = op || 0
  }
  get customerId() {
    return this._data.customerId
  }
  set customerId(customerId) {
    this._data.customerId = customerId || 0
  }
  get customerContact() {
    return this._data.customerContact
  }
  set customerContact(customerContact) {
    this._data.customerContact = customerContact
  }
  get contactTelephone() {
    return this._data.contactTelephone
  }
  set contactTelephone(contactTelephone) {
    this._data.contactTelephone = contactTelephone
  }
  get contactFax() {
    return this._data.contactFax
  }
  set contactFax(contactFax) {
    this._data.contactFax = contactFax
  }
  get designationAgent() {
    return this._data.designationAgent
  }
  set designationAgent(designationAgent) {
    this._data.designationAgent = designationAgent || 0
  }
  get destinationAgent() {
    return this._data.destinationAgent
  }
  set destinationAgent(destinationAgent) {
    this._data.destinationAgent = destinationAgent || 0
  }
  get localAgent() {
    return this._data.localAgent
  }
  set localAgent(localAgent) {
    this._data.localAgent = localAgent || 0
  }
  get masterAgent() {
    return this._data.masterAgent
  }
  set masterAgent(masterAgent) {
    this._data.masterAgent = masterAgent || false
  }
  get bookingAgent() {
    return this._data.bookingAgent
  }
  set bookingAgent(bookingAgent) {
    this._data.bookingAgent = bookingAgent || 0
  }
  get customsBroker() {
    return this._data.customsBroker
  }
  set customsBroker(customsBroker) {
    this._data.customsBroker = customsBroker || 0
  }
  get dispatchingPlace() {
    return this._data.dispatchingPlace
  }
  set dispatchingPlace(dispatchingPlace) {
    this._data.dispatchingPlace = dispatchingPlace
  }
  get dispatchingPlaceCode() {
    return this._data.dispatchingPlaceCode
  }
  set dispatchingPlaceCode(dispatchingPlaceCode) {
    this._data.dispatchingPlaceCode = dispatchingPlaceCode
  }
  get destinationPlace() {
    return this._data.destinationPlace
  }
  set destinationPlace(destinationPlace) {
    this._data.destinationPlace = destinationPlace
  }
  get destinationPlaceCode() {
    return this._data.destinationPlaceCode
  }
  set destinationPlaceCode(destinationPlaceCode) {
    this._data.destinationPlaceCode = destinationPlaceCode
  }
  get loadingPortCode() {
    return this._data.loadingPortCode
  }
  set loadingPortCode(loadingPortCode) {
    this._data.loadingPortCode = loadingPortCode
  }
  get dischargingPortCode() {
    return this._data.dischargingPortCode
  }
  set dischargingPortCode(dischargingPortCode) {
    this._data.dischargingPortCode = dischargingPortCode
  }
  get destinationPortCode() {
    return this._data.destinationPortCode
  }
  set destinationPortCode(destinationPortCode) {
    this._data.destinationPortCode = destinationPortCode
  }
  get quantityContract() {
    return this._data.quantityContract
  }
  set quantityContract(quantityContract) {
    this._data.quantityContract = quantityContract || 0
  }
  get weightContract() {
    return this._data.weightContract
  }
  set weightContract(weightContract) {
    this._data.weightContract = weightContract || 0
  }
  get cubageContract() {
    return this._data.cubageContract
  }
  set cubageContract(cubageContract) {
    this._data.cubageContract = cubageContract || 0
  }
  get quantityActual() {
    return this._data.quantityActual
  }
  set quantityActual(quantityActual) {
    this._data.quantityActual = quantityActual || 0
  }
  get weightActual() {
    return this._data.weightActual
  }
  set weightActual(weightActual) {
    this._data.weightActual = weightActual || 0
  }
  get cubageActual() {
    return this._data.cubageActual
  }
  set cubageActual(cubageActual) {
    this._data.cubageActual = cubageActual || 0
  }
  get chargeWeight() {
    return this._data.chargeWeight
  }
  set chargeWeight(chargeWeight) {
    this._data.chargeWeight = chargeWeight || 0
  }
  get volumetricWeight() {
    return this._data.volumetricWeight
  }
  set volumetricWeight(volumetricWeight) {
    this._data.volumetricWeight = volumetricWeight || 0
  }
  get chargeCubage() {
    return this._data.chargeCubage
  }
  set chargeCubage(chargeCubage) {
    this._data.chargeCubage = chargeCubage || 0
  }
  get measurements() {
    return this._data.measurements
  }
  set measurements(measurements) {
    this._data.measurements = measurements
  }
  get cargoType() {
    return this._data.cargoType
  }
  set cargoType(cargoType) {
    this._data.cargoType = cargoType
  }
  get freightTerm() {
    return this._data.freightTerm
  }
  set freightTerm(freightTerm) {
    this._data.freightTerm = freightTerm
  }
  get incoTerm() {
    return this._data.incoTerm
  }
  set incoTerm(incoTerm) {
    this._data.incoTerm = incoTerm
  }
  get packing() {
    return this._data.packing
  }
  set packing(packing) {
    this._data.packing = packing
  }
  get paymentTermMBL() {
    return this._data.paymentTermMBL
  }
  set paymentTermMBL(paymentTermMBL) {
    this._data.paymentTermMBL = paymentTermMBL
  }
  get paymentTermHBL() {
    return this._data.paymentTermHBL
  }
  set paymentTermHBL(paymentTermHBL) {
    this._data.paymentTermHBL = paymentTermHBL
  }
  get cargoChineseName() {
    return this._data.cargoChineseName
  }
  set cargoChineseName(cargoChineseName) {
    this._data.cargoChineseName = cargoChineseName
  }
  get cargoEnglishName() {
    return this._data.cargoEnglishName
  }
  set cargoEnglishName(cargoEnglishName) {
    this._data.cargoEnglishName = cargoEnglishName
  }
  get mark() {
    return this._data.mark
  }
  set mark(mark) {
    this._data.mark = mark
  }
  get carrierId() {
    return this._data.carrierId
  }
  set carrierId(carrierId) {
    this._data.carrierId = carrierId || 0
  }
  get carrierAgentId() {
    return this._data.carrierAgentId
  }
  set carrierAgentId(carrierAgentId) {
    this._data.carrierAgentId = carrierAgentId || 0
  }
  get vessel() {
    return this._data.vessel
  }
  set vessel(vessel) {
    this._data.vessel = vessel
  }
  get voyageFlight() {
    return this._data.voyageFlight
  }
  set voyageFlight(voyageFlight) {
    this._data.voyageFlight = voyageFlight
  }
  get etd() {
    return this._data.etd
  }
  set etd(etd) {
    this._data.etd = etd
  }
  get eta() {
    return this._data.eta
  }
  set eta(eta) {
    this._data.eta = eta
  }
  get ata() {
    return this._data.ata
  }
  set ata(ata) {
    this._data.ata = ata
  }
  get bookingDate() {
    return this._data.bookingDate
  }
  set bookingDate(bookingDate) {
    this._data.bookingDate = bookingDate
  }
  get jobState() {
    return this._data.jobState
  }
  set jobState(jobState) {
    this._data.jobState = jobState || 0
  }
  get comission() {
    return this._data.comission
  }
  set comission(comission) {
    this._data.comission = comission || 0
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get businessDate() {
    return this._data.businessDate
  }
  set businessDate(businessDate) {
    this._data.businessDate = businessDate
  }
  get lob() {
    return this._data.lob
  }
  set lob(lob) {
    this._data.lob = lob
  }
  get shutOut() {
    return this._data.shutOut
  }
  set shutOut(shutOut) {
    this._data.shutOut = shutOut
  }
  get satisfiedRequests() {
    return this._data.satisfiedRequests
  }
  set satisfiedRequests(satisfiedRequests) {
    this._data.satisfiedRequests = satisfiedRequests
  }
  get dcOffice() {
    return this._data.dcOffice
  }
  set dcOffice(dcOffice) {
    this._data.dcOffice = dcOffice || 0
  }
  get dcDepartment() {
    return this._data.dcDepartment
  }
  set dcDepartment(dcDepartment) {
    this._data.dcDepartment = dcDepartment || 0
  }
  get dc() {
    return this._data.dc
  }
  set dc(dc) {
    this._data.dc = dc || 0
  }
  get poNo() {
    return this._data.poNo
  }
  set poNo(poNo) {
    this._data.poNo = poNo
  }
  get projectName() {
    return this._data.projectName
  }
  set projectName(projectName) {
    this._data.projectName = projectName
  }
  get projectBatch() {
    return this._data.projectBatch
  }
  set projectBatch(projectBatch) {
    this._data.projectBatch = projectBatch
  }
  get agentLevel() {
    return this._data.agentLevel
  }
  set agentLevel(agentLevel) {
    this._data.agentLevel = agentLevel
  }
  get cargoSource() {
    return this._data.cargoSource
  }
  set cargoSource(cargoSource) {
    this._data.cargoSource = cargoSource
  }
  get containerDesc() {
    return this._data.containerDesc
  }
  set containerDesc(containerDesc) {
    this._data.containerDesc = containerDesc
  }
  get teu() {
    return this._data.teu
  }
  set teu(teu) {
    this._data.teu = teu || 0
  }
  get profit() {
    return this._data.profit
  }
  set profit(profit) {
    this._data.profit = profit || 0
  }
  get warehousing() {
    return this._data.warehousing
  }
  set warehousing(warehousing) {
    this._data.warehousing = warehousing || false
  }
  get landTransportation() {
    return this._data.landTransportation
  }
  set landTransportation(landTransportation) {
    this._data.landTransportation = landTransportation || false
  }
  get international() {
    return this._data.international
  }
  set international(international) {
    this._data.international = international || false
  }
  get multiplePickups() {
    return this._data.multiplePickups
  }
  set multiplePickups(multiplePickups) {
    this._data.multiplePickups = multiplePickups || false
  }
  get advance() {
    return this._data.advance
  }
  set advance(advance) {
    this._data.advance = advance || false
  }
  get blocked() {
    return this._data.blocked
  }
  set blocked(blocked) {
    this._data.blocked = blocked || false
  }
  get express() {
    return this._data.express
  }
  set express(express) {
    this._data.express = express || false
  }
  get declareCustomsState() {
    return this._data.declareCustomsState
  }
  set declareCustomsState(declareCustomsState) {
    this._data.declareCustomsState = declareCustomsState || 0
  }
  get warehouseNoFormat() {
    return this._data.warehouseNoFormat
  }
  set warehouseNoFormat(warehouseNoFormat) {
    this._data.warehouseNoFormat = warehouseNoFormat
  }
  get shipperId() {
    return this._data.shipperId
  }
  set shipperId(shipperId) {
    this._data.shipperId = shipperId || 0
  }
  get consigneeId() {
    return this._data.consigneeId
  }
  set consigneeId(consigneeId) {
    this._data.consigneeId = consigneeId || 0
  }
  get notifyId() {
    return this._data.notifyId
  }
  set notifyId(notifyId) {
    this._data.notifyId = notifyId || 0
  }
  get preverifyState() {
    return this._data.preverifyState
  }
  // 待审核 1，已审核 2，已拒绝 3，暂不提交 4，复核通过 5，复核拒绝 6
  set preverifyState(preverifyState) {
    this._data.preverifyState = preverifyState || 0
  }
  get trustFromJob() {
    return this._data.trustFromJob
  }
  set trustFromJob(trustFromJob) {
    this._data.trustFromJob = trustFromJob
  }
  get signMBL() {
    return this._data.signMBL
  }
  set signMBL(signMBL) {
    this._data.signMBL = signMBL || false
  }
  get signHBL() {
    return this._data.signHBL
  }
  set signHBL(signHBL) {
    this._data.signHBL = signHBL || false
  }
  get estimateAccountsReceivable() {
    return this._data.estimateAccountsReceivable
  }
  set estimateAccountsReceivable(estimateAccountsReceivable) {
    this._data.estimateAccountsReceivable = estimateAccountsReceivable || 0
  }
  get estimateAccountsPayable() {
    return this._data.estimateAccountsPayable
  }
  set estimateAccountsPayable(estimateAccountsPayable) {
    this._data.estimateAccountsPayable = estimateAccountsPayable || 0
  }
  get estimateGrossProfit() {
    return this._data.estimateGrossProfit
  }
  set estimateGrossProfit(estimateGrossProfit) {
    this._data.estimateGrossProfit = estimateGrossProfit || 0
  }
  get shipperCode() {
    return this._data.shipperCode
  }
  set shipperCode(shipperCode) {
    this._data.shipperCode = shipperCode
  }
  get shipperLine1() {
    return this._data.shipperLine1
  }
  set shipperLine1(shipperLine1) {
    this._data.shipperLine1 = shipperLine1
  }
  get shipperLine2() {
    return this._data.shipperLine2
  }
  set shipperLine2(shipperLine2) {
    this._data.shipperLine2 = shipperLine2
  }
  get shipperLine3() {
    return this._data.shipperLine3
  }
  set shipperLine3(shipperLine3) {
    this._data.shipperLine3 = shipperLine3
  }
  get shipperLine4() {
    return this._data.shipperLine4
  }
  set shipperLine4(shipperLine4) {
    this._data.shipperLine4 = shipperLine4
  }
  get shipperLine5() {
    return this._data.shipperLine5
  }
  set shipperLine5(shipperLine5) {
    this._data.shipperLine5 = shipperLine5
  }
  get shipperLine6() {
    return this._data.shipperLine6
  }
  set shipperLine6(shipperLine6) {
    this._data.shipperLine6 = shipperLine6
  }
  get shipperLine7() {
    return this._data.shipperLine7
  }
  set shipperLine7(shipperLine7) {
    this._data.shipperLine7 = shipperLine7
  }
  get consigneeCode() {
    return this._data.consigneeCode
  }
  set consigneeCode(consigneeCode) {
    this._data.consigneeCode = consigneeCode
  }
  get consigneeLine1() {
    return this._data.consigneeLine1
  }
  set consigneeLine1(consigneeLine1) {
    this._data.consigneeLine1 = consigneeLine1
  }
  get consigneeLine2() {
    return this._data.consigneeLine2
  }
  set consigneeLine2(consigneeLine2) {
    this._data.consigneeLine2 = consigneeLine2
  }
  get consigneeLine3() {
    return this._data.consigneeLine3
  }
  set consigneeLine3(consigneeLine3) {
    this._data.consigneeLine3 = consigneeLine3
  }
  get consigneeLine4() {
    return this._data.consigneeLine4
  }
  set consigneeLine4(consigneeLine4) {
    this._data.consigneeLine4 = consigneeLine4
  }
  get consigneeLine5() {
    return this._data.consigneeLine5
  }
  set consigneeLine5(consigneeLine5) {
    this._data.consigneeLine5 = consigneeLine5
  }
  get consigneeLine6() {
    return this._data.consigneeLine6
  }
  set consigneeLine6(consigneeLine6) {
    this._data.consigneeLine6 = consigneeLine6
  }
  get consigneeLine7() {
    return this._data.consigneeLine7
  }
  set consigneeLine7(consigneeLine7) {
    this._data.consigneeLine7 = consigneeLine7
  }
  get notifyCode() {
    return this._data.notifyCode
  }
  set notifyCode(notifyCode) {
    this._data.notifyCode = notifyCode
  }
  get notifyLine1() {
    return this._data.notifyLine1
  }
  set notifyLine1(notifyLine1) {
    this._data.notifyLine1 = notifyLine1
  }
  get notifyLine2() {
    return this._data.notifyLine2
  }
  set notifyLine2(notifyLine2) {
    this._data.notifyLine2 = notifyLine2
  }
  get notifyLine3() {
    return this._data.notifyLine3
  }
  set notifyLine3(notifyLine3) {
    this._data.notifyLine3 = notifyLine3
  }
  get notifyLine4() {
    return this._data.notifyLine4
  }
  set notifyLine4(notifyLine4) {
    this._data.notifyLine4 = notifyLine4
  }
  get notifyLine5() {
    return this._data.notifyLine5
  }
  set notifyLine5(notifyLine5) {
    this._data.notifyLine5 = notifyLine5
  }
  get notifyLine6() {
    return this._data.notifyLine6
  }
  set notifyLine6(notifyLine6) {
    this._data.notifyLine6 = notifyLine6
  }
  get notifyLine7() {
    return this._data.notifyLine7
  }
  set notifyLine7(notifyLine7) {
    this._data.notifyLine7 = notifyLine7
  }
  get alsoNotify() {
    return this._data.alsoNotify
  }
  set alsoNotify(alsoNotify) {
    this._data.alsoNotify = alsoNotify
  }
  get bookingRefuseNote() {
    return this._data.bookingRefuseNote
  }
  set bookingRefuseNote(bookingRefuseNote) {
    this._data.bookingRefuseNote = bookingRefuseNote
  }
  get customsDate() {
    return this._data.customsDate
  }
  set customsDate(customsDate) {
    this._data.customsDate = customsDate
  }
  get customsRemarks() {
    return this._data.customsRemarks
  }
  set customsRemarks(customsRemarks) {
    this._data.customsRemarks = customsRemarks
  }
  get hsCode() {
    return this._data.hsCode
  }
  set hsCode(hsCode) {
    this._data.hsCode = hsCode
  }
  get operationContent() {
    return this._data.operationContent
  }
  set operationContent(operationContent) {
    this._data.operationContent = operationContent
  }
  get situation() {
    return this._data.situation
  }
  set situation(situation) {
    this._data.situation = situation
  }
  get atd() {
    return this._data.atd
  }
  set atd(atd) {
    this._data.atd = atd
  }
  get checkData() {
    return this._data.checkData
  }
  set checkData(checkData) {
    this._data.checkData = checkData || false
  }
  get virtualHBL() {
    return this._data.virtualHBL
  }
  set virtualHBL(virtualHBL) {
    this._data.virtualHBL = virtualHBL || false
  }
  get receivableState() {
    return this._data.receivableState
  }
  set receivableState(receivableState) {
    this._data.receivableState = receivableState || 0
  }
  get payablesState() {
    return this._data.payablesState
  }
  set payablesState(payablesState) {
    this._data.payablesState = payablesState || 0
  }
  get priceNo() {
    return this._data.priceNo
  }
  set priceNo(priceNo) {
    this._data.priceNo = priceNo
  }
  get booking() {
    return this._data.booking
  }
  set booking(booking) {
    this._data.booking = booking || false
  }
  get priceTier() {
    return this._data.priceTier
  }
  set priceTier(priceTier) {
    this._data.priceTier = priceTier || 0
  }
  get selfDeliver() {
    return this._data.selfDeliver
  }
  set selfDeliver(selfDeliver) {
    this._data.selfDeliver = selfDeliver || false
  }
  get bookingState() {
    return this._data.bookingState
  }
  set bookingState(bookingState) {
    this._data.bookingState = bookingState || 0
  }
  get itmService() {
    return this._data.itmService
  }
  set itmService(itmService) {
    this._data.itmService = itmService || false
  }
  get customsJobNo() {
    return this._data.customsJobNo
  }
  set customsJobNo(customsJobNo) {
    this._data.customsJobNo = customsJobNo
  }
  get customJobType() {
    return this._data.customJobType
  }
  set customJobType(customJobType) {
    this._data.customJobType = customJobType
  }
  get preverifier() {
    return this._data.preverifier
  }
  set preverifier(preverifier) {
    this._data.preverifier = preverifier || 0
  }
  get preverifyDate() {
    return this._data.preverifyDate
  }
  set preverifyDate(preverifyDate) {
    this._data.preverifyDate = preverifyDate
  }
  get salePrice() {
    return this._data.salePrice
  }
  set salePrice(salePrice) {
    this._data.salePrice = salePrice || false
  }
  get salePriceRemarks() {
    return this._data.salePriceRemarks
  }
  set salePriceRemarks(salePriceRemarks) {
    this._data.salePriceRemarks = salePriceRemarks
  }
  get salesChannel() {
    return this._data.salesChannel
  }
  set salesChannel(salesChannel) {
    this._data.salesChannel = salesChannel
  }
  get depositReceived() {
    return this._data.depositReceived
  }
  set depositReceived(depositReceived) {
    this._data.depositReceived = depositReceived || 0
  }
  get contactEmail() {
    return this._data.contactEmail
  }
  set contactEmail(contactEmail) {
    this._data.contactEmail = contactEmail
  }
  get provisioned() {
    return this._data.provisioned
  }
  set provisioned(provisioned) {
    this._data.provisioned = provisioned || false
  }
  get provisionedDate() {
    return this._data.provisionedDate
  }
  set provisionedDate(provisionedDate) {
    this._data.provisionedDate = provisionedDate
  }
  get provisionedBy() {
    return this._data.provisionedBy
  }
  set provisionedBy(provisionedBy) {
    this._data.provisionedBy = provisionedBy || 0
  }
  get planner() {
    return this._data.planner
  }
  set planner(planner) {
    this._data.planner = planner || 0
  }
  get plannerDepartment() {
    return this._data.plannerDepartment
  }
  set plannerDepartment(plannerDepartment) {
    this._data.plannerDepartment = plannerDepartment || 0
  }
  get plannerOffice() {
    return this._data.plannerOffice
  }
  set plannerOffice(plannerOffice) {
    this._data.plannerOffice = plannerOffice || 0
  }
  get riverCarrierId() {
    return this._data.riverCarrierId
  }
  set riverCarrierId(riverCarrierId) {
    this._data.riverCarrierId = riverCarrierId || 0
  }
  get tradeTerm() {
    return this._data.tradeTerm
  }
  set tradeTerm(tradeTerm) {
    this._data.tradeTerm = tradeTerm
  }
  get overseaOpDepartment() {
    return this._data.overseaOpDepartment
  }
  set overseaOpDepartment(overseaOpDepartment) {
    this._data.overseaOpDepartment = overseaOpDepartment || 0
  }
  get overseaOp() {
    return this._data.overseaOp
  }
  set overseaOp(overseaOp) {
    this._data.overseaOp = overseaOp || 0
  }
  get userDefinedField1() {
    return this._data.userDefinedField1
  }
  set userDefinedField1(userDefinedField1) {
    this._data.userDefinedField1 = userDefinedField1
  }
  get userDefinedField2() {
    return this._data.userDefinedField2
  }
  set userDefinedField2(userDefinedField2) {
    this._data.userDefinedField2 = userDefinedField2
  }
  get userDefinedField3() {
    return this._data.userDefinedField3
  }
  set userDefinedField3(userDefinedField3) {
    this._data.userDefinedField3 = userDefinedField3
  }
  get manageAuditRemark() {
    return this._data.manageAuditRemark
  }
  set manageAuditRemark(manageAuditRemark) {
    this._data.manageAuditRemark = manageAuditRemark
  }
  get manageAuditRejectRemark() {
    return this._data.manageAuditRejectRemark
  }
  set manageAuditRejectRemark(manageAuditRejectRemark) {
    this._data.manageAuditRejectRemark = manageAuditRejectRemark
  }
  get manageAuditStatus() {
    return this._data.manageAuditStatus
  }
  set manageAuditStatus(manageAuditStatus) {
    this._data.manageAuditStatus = manageAuditStatus || 0
  }
  get submitterUser() {
    return this._data.submitterUser
  }
  set submitterUser(submitterUser) {
    this._data.submitterUser = submitterUser || 0
  }
  get auditCheckNode() {
    return this._data.auditCheckNode
  }
  set auditCheckNode(auditCheckNode) {
    this._data.auditCheckNode = auditCheckNode || 0
  }
  get typeHBL() {
    return this._data.typeHBL
  }
  set typeHBL(typeHBL) {
    this._data.typeHBL = typeHBL || 0
  }
  get typeMBL() {
    return this._data.typeMBL
  }
  set typeMBL(typeMBL) {
    this._data.typeMBL = typeMBL || 0
  }
  get ifPushSopM() {
    return this._data.ifPushSopM
  }
  set ifPushSopM(ifPushSopM) {
    this._data.ifPushSopM = ifPushSopM || false
  }
  get ifPushSopZ() {
    return this._data.ifPushSopZ
  }
  set ifPushSopZ(ifPushSopZ) {
    this._data.ifPushSopZ = ifPushSopZ || false
  }
  get ifPushSopQ() {
    return this._data.ifPushSopQ
  }
  set ifPushSopQ(ifPushSopQ) {
    this._data.ifPushSopQ = ifPushSopQ || false
  }
  get ifPushSop() {
    return this._data.ifPushSop
  }
  set ifPushSop(ifPushSop) {
    this._data.ifPushSop = ifPushSop || false
  }
  get changeState() {
    return this._data.changeState
  }
  set changeState(changeState) {
    this._data.changeState = changeState || 0
  }
  get cargoSalesId() {
    return this._data.cargoSalesId
  }
  set cargoSalesId(cargoSalesId) {
    this._data.cargoSalesId = cargoSalesId || 0
  }
  get changeBy() {
    return this._data.changeBy
  }
  set changeBy(changeBy) {
    this._data.changeBy = changeBy || 0
  }
  get changeDate() {
    return this._data.changeDate
  }
  set changeDate(changeDate) {
    this._data.changeDate = changeDate
  }
  get closingAccountStatus() {
    return this._data.closingAccountStatus
  }
  set closingAccountStatus(closingAccountStatus) {
    if (closingAccountStatus !== 0) {
      closingAccountStatus = closingAccountStatus || 0
    }
    this._data.closingAccountStatus = closingAccountStatus
  }
  get firstProvisionedDate() {
    return this._data.firstProvisionedDate
  }
  set firstProvisionedDate(firstProvisionedDate) {
    this._data.firstProvisionedDate = firstProvisionedDate
  }
  get firstProvisionedProfit() {
    return this._data.firstProvisionedProfit
  }
  set firstProvisionedProfit(firstProvisionedProfit) {
    this._data.firstProvisionedProfit = firstProvisionedProfit || 0
  }
  get provisionedProfit() {
    return this._data.provisionedProfit
  }
  set provisionedProfit(provisionedProfit) {
    this._data.provisionedProfit = provisionedProfit || 0
  }
  get provisionedStatus() {
    return this._data.provisionedStatus
  }
  set provisionedStatus(provisionedStatus) {
    if (provisionedStatus !== 0) {
      provisionedStatus = provisionedStatus || 0
    }
    this._data.provisionedStatus = provisionedStatus
  }
  get salesRequire() {
    return this._data.salesRequire
  }
  set salesRequire(salesRequire) {
    this._data.salesRequire = salesRequire
  }
  get userDefinedField4() {
    return this._data.userDefinedField4
  }
  set userDefinedField4(userDefinedField4) {
    this._data.userDefinedField4 = userDefinedField4
  }
  get vesselPortArea() {
    return this._data.vesselPortArea
  }
  set vesselPortArea(vesselPortArea) {
    this._data.vesselPortArea = vesselPortArea
  }
  get voyageFlightPortArea() {
    return this._data.voyageFlightPortArea
  }
  set voyageFlightPortArea(voyageFlightPortArea) {
    this._data.voyageFlightPortArea = voyageFlightPortArea
  }
  get orderUuid() {
    return this._data.orderUuid
  }
  set orderUuid(orderUuid) {
    this._data.orderUuid = orderUuid
  }
  get jointMasterMBLUuid() {
    return this._data.jointMasterMBLUuid
  }
  set jointMasterMBLUuid(jointMasterMBLUuid) {
    this._data.jointMasterMBLUuid = jointMasterMBLUuid
  }
  get lclMasterUuid() {
    return this._data.lclMasterUuid
  }
  set lclMasterUuid(lclMasterUuid) {
    this._data.lclMasterUuid = lclMasterUuid
  }
  get jointMasterHBLUuid() {
    return this._data.jointMasterHBLUuid
  }
  set jointMasterHBLUuid(jointMasterHBLUuid) {
    this._data.jointMasterHBLUuid = jointMasterHBLUuid
  }
  get jointMasterHBL() {
    return this._data.jointMasterHBL
  }
  set jointMasterHBL(jointMasterHBL) {
    this._data.jointMasterHBL = jointMasterHBL
  }
  get airFlightDetailUuid() {
    return this._data.airFlightDetailUuid
  }
  set airFlightDetailUuid(airFlightDetailUuid) {
    this._data.airFlightDetailUuid = airFlightDetailUuid
  }
  get hblNb3() {
    return this._data.hblNb3
  }
  set hblNb3(hblNb3) {
    this._data.hblNb3 = hblNb3
  }
  get customerTypeId() {
    return this._data.customerTypeId
  }
  set customerTypeId(customerTypeId) {
    this._data.customerTypeId = customerTypeId
  }
  get contractStatus() {
    return this._data.contractStatus
  }
  set contractStatus(contractStatus) {
    this._data.contractStatus = contractStatus
  }
  get jobNoRule() {
    return this._data.jobNoRule
  }
  set jobNoRule(jobNoRule) {
    this._data.jobNoRule = jobNoRule
  }
  get operateNameCode() {
    return this._data.operateNameCode
  }
  set operateNameCode(operateNameCode) {
    this._data.operateNameCode = operateNameCode
  }
  get relatedJobUuid() {
    return this._data.relatedJobUuid
  }
  set relatedJobUuid(relatedJobUuid) {
    this._data.relatedJobUuid = relatedJobUuid
  }
  get fileSourceContent() {
    return this._data.fileSourceContent
  }
  set fileSourceContent(fileSourceContent) {
    this._data.fileSourceContent = fileSourceContent
  }
  get fileSourceType() {
    return this._data.fileSourceType
  }
  set fileSourceType(fileSourceType) {
    this._data.fileSourceType = fileSourceType
  }
  get fileSourceName() {
    return this._data.fileSourceName
  }
  set fileSourceName(fileSourceName) {
    this._data.fileSourceName = fileSourceName
  }
  get taxNature() {
    return this._data.taxNature
  }
  set taxNature(taxNature) {
    this._data.taxNature = taxNature
  }
  get danUNNo() {
    return this._data.danUNNo
  }
  set danUNNo(danUNNo) {
    this._data.danUNNo = danUNNo
  }
  get masterJobNo() {
    return this._data.masterJobNo
  }
  set masterJobNo(masterJobNo) {
    this._data.masterJobNo = masterJobNo
  }
  get usCustomsClearance() {
    return this._data.usCustomsClearance
  }
  set usCustomsClearance(usCustomsClearance) {
    this._data.usCustomsClearance = usCustomsClearance || false
  }
  get exChangeAgent() {
    return this._data.exChangeAgent
  }
  set exChangeAgent(exChangeAgent) {
    this._data.exChangeAgent = exChangeAgent || 0
  }
  get dischargingPortDoor() {
    return this._data.dischargingPortDoor
  }
  set dischargingPortDoor(dischargingPortDoor) {
    this._data.dischargingPortDoor = dischargingPortDoor || false
  }
  get destinationPortService() {
    return this._data.destinationPortService
  }
  set destinationPortService(destinationPortService) {
    this._data.destinationPortService = destinationPortService || false
  }
  get multipleDischargingPickups() {
    return this._data.multipleDischargingPickups
  }
  set multipleDischargingPickups(multipleDischargingPickups) {
    this._data.multipleDischargingPickups = multipleDischargingPickups || false
  }
  get warehouseStatus() { // 入库状态-默认未入库
    return this._data.warehouseStatus
  }
  set warehouseStatus(warehouseStatus) {
    this._data.warehouseStatus = warehouseStatus || 0
  }
  /* 关联实体-begin */
  get seaEQ() {
    return this._data.seaEQ
  }
  set seaEQ(seaEQ) {
    this._data.seaEQ = seaEQ
  }
  get containerUsages() {
    return this._data.containerUsages
  }
  set containerUsages(containerUsages) {
    this._data.containerUsages = containerUsages
  }
  get containers() {
    return this._data.containers
  }
  set containers(containers) {
    this._data.containers = containers
  }
  get airUld() {
    return this._data.airUld
  }
  set airUld(airUld) {
    this._data.airUld = airUld
  }
  get unitLoadDeviceUsages() {
    return this._data.unitLoadDeviceUsages
  }
  set unitLoadDeviceUsages(unitLoadDeviceUsages) {
    this._data.unitLoadDeviceUsages = unitLoadDeviceUsages
  }
  get unitLoadDevices() {
    return this._data.unitLoadDevices
  }
  set unitLoadDevices(unitLoadDevices) {
    this._data.unitLoadDevices = unitLoadDevices
  }
  get cargoDoc() {
    return this._data.cargoDoc
  }
  set cargoDoc(cargoDoc) {
    this._data.cargoDoc = cargoDoc
  }
  get lclSlaves() {
    return this._data.lclSlaves
  }
  set lclSlaves(lclSlaves) {
    this._data.lclSlaves = lclSlaves
  }
  get jointSlavesMBL() {
    return this._data.jointSlavesMBL
  }
  set jointSlavesMBL(jointSlavesMBL) {
    this._data.jointSlavesMBL = jointSlavesMBL
  }
  get jointSlavesHBL() {
    return this._data.jointSlavesHBL
  }
  set jointSlavesHBL(jointSlavesHBL) {
    this._data.jointSlavesHBL = jointSlavesHBL
  }
  get jointSlavesHAWB2() {
    return this._data.jointSlavesHAWB2
  }
  set jointSlavesHAWB2(jointSlavesHAWB2) {
    this._data.jointSlavesHAWB2 = jointSlavesHAWB2
  }
  get quotationNo() { // 报价单号
    return this._data.quotationNo
  }
  set quotationNo(quotationNo) {
    this._data.quotationNo = quotationNo
  }
  get charges() {
    return this._data.charges
  }
  set charges(charges) {
    this._data.charges = charges
  }
  get bills() {
    return this._data.bills
  }
  set bills(bills) {
    this._data.bills = bills
  }
  get containerRef() {
    return this._data.containerRef
  }
  set containerRef(containerRef) {
    this._data.containerRef = containerRef
  }
  get poItems() {
    return this._data.poItems
  }
  set poItems(poItems) {
    this._data.poItems = poItems
  }
  get poList() {
    return this._data.poList
  }
  set poList(poList) {
    this._data.poList = poList
  }
  get manifestInfos() {
    return this._data.manifestInfos
  }
  set manifestInfos(manifestInfos) {
    this._data.manifestInfos = manifestInfos
  }
  get manifestInfoPage() {
    return this._data.manifestInfoPage || false
  }
  set manifestInfoPage(manifestInfoPage) {
    this._data.manifestInfoPage = manifestInfoPage
  }
  get truckingPage() {
    return this._data.truckingPage || false
  }
  set truckingPage(truckingPage) {
    this._data.truckingPage = truckingPage
  }
  get warehouseInfo() {
    return this._data.warehouseInfo
  }
  set warehouseInfo(warehouseInfo) {
    this._data.warehouseInfo = warehouseInfo
  }
  get warehouseIn() {
    return this._data.warehouseIn
  }
  set warehouseIn(warehouseIn) {
    this._data.warehouseIn = warehouseIn
  }
  get jobWarehouseNos() {
    return this._data.jobWarehouseNos
  }
  set jobWarehouseNos(jobWarehouseNos) {
    this._data.jobWarehouseNos = jobWarehouseNos
  }
  get trucking() {
    return this._data.trucking
  }
  set trucking(trucking) {
    this._data.trucking = trucking
  }
  get truckingInfoPods() {
    return this._data.truckingInfoPods
  }
  set truckingInfoPods(truckingInfoPods) {
    this._data.truckingInfoPods = truckingInfoPods
  }
  get dischargingTrucking() {
    return this._data.dischargingTrucking
  }
  set dischargingTrucking(dischargingTrucking) {
    this._data.dischargingTrucking = dischargingTrucking
  }
  get destPortCustomsDataList() {
    return this._data.destPortCustomsDataList
  }
  set destPortCustomsDataList(destPortCustomsDataList) {
    this._data.destPortCustomsDataList = destPortCustomsDataList
  }
  get trackingInfo() {
    return this._data.trackingInfo
  }
  set trackingInfo(trackingInfo) {
    this._data.trackingInfo = trackingInfo
  }
  get customsInfo() {
    return this._data.customsInfo
  }
  set customsInfo(customsInfo) {
    this._data.customsInfo = customsInfo
  }
  get file() {
    return this._data.file
  }
  set file(file) {
    this._data.file = file
  }
  get surchargeTerms() {
    return this._data.surchargeTerms
  }
  set surchargeTerms(surchargeTerms) {
    this._data.surchargeTerms = surchargeTerms
  }
  get specialGoods() {
    return this._data.specialGoods
  }
  set specialGoods(specialGoods) {
    this._data.specialGoods = specialGoods
  }
  get jointMasterMBL() {
    return this._data.jointMasterMBL
  }
  set jointMasterMBL(jointMasterMBL) {
    this._data.jointMasterMBL = jointMasterMBL
  }
  get lclMaster() {
    return this._data.lclMaster
  }
  set lclMaster(lclMaster) {
    this._data.lclMaster = lclMaster
  }
  // fbaJob
  get fbaJob() {
    return this._data.fbaJob
  }
  set fbaJob(fbaJob) {
    this._data.fbaJob = fbaJob
  }
  /* 关联实体-end */

  get delContainerUuids() {
    return this._data.delContainerUuids
  }
  set delContainerUuids(delContainerUuids) {
    this._data.delContainerUuids = delContainerUuids
  }

  get delWarehouseInfoUuids() {
    return this._data.delWarehouseInfoUuids
  }
  set delWarehouseInfoUuids(delWarehouseInfoUuids) {
    this._data.delWarehouseInfoUuids = delWarehouseInfoUuids
  }

  get receivableChargeLockedStatus() {
    return this._data.receivableChargeLockedStatus
  }
  set receivableChargeLockedStatus(receivableChargeLockedStatus) {
    this._data.receivableChargeLockedStatus = receivableChargeLockedStatus || 0
  }

  get payableChargeLockedStatus() {
    return this._data.payableChargeLockedStatus
  }
  set payableChargeLockedStatus(payableChargeLockedStatus) {
    this._data.payableChargeLockedStatus = payableChargeLockedStatus || 0
  }

  get receivableChargeLockedDate() {
    return this._data.receivableChargeLockedDate
  }
  set receivableChargeLockedDate(receivableChargeLockedDate) {
    this._data.receivableChargeLockedDate = receivableChargeLockedDate || null
  }

  get payableChargeLockedDate() {
    return this._data.payableChargeLockedDate
  }
  set payableChargeLockedDate(payableChargeLockedDate) {
    this._data.payableChargeLockedDate = payableChargeLockedDate || null
  }

  // 是否前置仓
  get backUpWarehouse() {
    return this._data.backUpWarehouse
  }
  set backUpWarehouse(backUpWarehouse) {
    this._data.backUpWarehouse = backUpWarehouse || false
  }
  get backUpWarehouseInfo() {
    return this._data.backUpWarehouseInfo
  }
  set backUpWarehouseInfo(backUpWarehouseInfo) {
    this._data.backUpWarehouseInfo = backUpWarehouseInfo
  }

  // 用于打印中 记录的 客户特殊需求选择的id
  get requestSelectedKeys() {
    return this._data.requestSelectedKeys
  }
  set requestSelectedKeys(requestSelectedKeys) {
    this._data.requestSelectedKeys = requestSelectedKeys
  }

  // ==================================拓展字段================
  // 运输公司
  get carryingCmp() {
    return this._data.carryingCmp
  }
  set carryingCmp(carryingCmp) {
    this._data.carryingCmp = carryingCmp || 0
  }

  // 仓库
  get warehouseCmp() {
    return this._data.warehouseCmp
  }
  set warehouseCmp(warehouseCmp) {
    this._data.warehouseCmp = warehouseCmp || 0
  }

  // 仓库名称
  get warehouseName() {
    return this._data.warehouseName
  }
  set warehouseName(warehouseName) {
    this._data.warehouseName = warehouseName
  }

  // 前置仓
  get backUpWarehouseCmp() {
    return this._data.backUpWarehouseCmp
  }
  set backUpWarehouseCmp(backUpWarehouseCmp) {
    this._data.backUpWarehouseCmp = backUpWarehouseCmp || 0
  }

  // 自定义岗位1
  get userDefinedRoleId1() {
    return this._data.userDefinedRoleId1
  }
  set userDefinedRoleId1(userDefinedRoleId1) {
    this._data.userDefinedRoleId1 = userDefinedRoleId1 || 0
  }
  get userDefinedRoleDept1() {
    return this._data.userDefinedRoleDept1
  }
  set userDefinedRoleDept1(userDefinedRoleDept1) {
    this._data.userDefinedRoleDept1 = userDefinedRoleDept1 || 0
  }
  get userDefinedRoleOffice1() {
    return this._data.userDefinedRoleOffice1
  }
  set userDefinedRoleOffice1(userDefinedRoleOffice1) {
    this._data.userDefinedRoleOffice1 = userDefinedRoleOffice1 || 0
  }

  // 自定义岗位2
  get userDefinedRoleId2() {
    return this._data.userDefinedRoleId2
  }
  set userDefinedRoleId2(userDefinedRoleId2) {
    this._data.userDefinedRoleId2 = userDefinedRoleId2 || 0
  }
  get userDefinedRoleDept2() {
    return this._data.userDefinedRoleDept2
  }
  set userDefinedRoleDept2(userDefinedRoleDept2) {
    this._data.userDefinedRoleDept2 = userDefinedRoleDept2 || 0
  }
  get userDefinedRoleOffice2() {
    return this._data.userDefinedRoleOffice2
  }
  set userDefinedRoleOffice2(userDefinedRoleOffice2) {
    this._data.userDefinedRoleOffice2 = userDefinedRoleOffice2 || 0
  }
  // 自定义岗位5
  get userDefinedRoleId5() {
    return this._data.userDefinedRoleId5
  }
  set userDefinedRoleId5(userDefinedRoleId5) {
    this._data.userDefinedRoleId5 = userDefinedRoleId5 || 0
  }
  get userDefinedRoleDept5() {
    return this._data.userDefinedRoleDept5
  }
  set userDefinedRoleDept5(userDefinedRoleDept5) {
    this._data.userDefinedRoleDept5 = userDefinedRoleDept5 || 0
  }
  get userDefinedRoleOffice5() {
    return this._data.userDefinedRoleOffice5
  }
  set userDefinedRoleOffice5(userDefinedRoleOffice5) {
    this._data.userDefinedRoleOffice5 = userDefinedRoleOffice5 || 0
  }
  // 自定义岗位6
  get userDefinedRoleId6() {
    return this._data.userDefinedRoleId6
  }
  set userDefinedRoleId6(userDefinedRoleId6) {
    this._data.userDefinedRoleId6 = userDefinedRoleId6 || 0
  }
  get userDefinedRoleDept6() {
    return this._data.userDefinedRoleDept6
  }
  set userDefinedRoleDept6(userDefinedRoleDept6) {
    this._data.userDefinedRoleDept6 = userDefinedRoleDept6 || 0
  }
  get userDefinedRoleOffice6() {
    return this._data.userDefinedRoleOffice6
  }
  set userDefinedRoleOffice6(userDefinedRoleOffice6) {
    this._data.userDefinedRoleOffice6 = userDefinedRoleOffice6 || 0
  }
  // 自定义岗位7
  get userDefinedRoleId7() {
    return this._data.userDefinedRoleId7
  }
  set userDefinedRoleId7(userDefinedRoleId7) {
    this._data.userDefinedRoleId7 = userDefinedRoleId7 || 0
  }
  get userDefinedRoleDept7() {
    return this._data.userDefinedRoleDept7
  }
  set userDefinedRoleDept7(userDefinedRoleDept7) {
    this._data.userDefinedRoleDept7 = userDefinedRoleDept7 || 0
  }
  get userDefinedRoleOffice7() {
    return this._data.userDefinedRoleOffice7
  }
  set userDefinedRoleOffice7(userDefinedRoleOffice7) {
    this._data.userDefinedRoleOffice7 = userDefinedRoleOffice7 || 0
  }
  get trackingTemplateUuid() {
    return this._data.trackingTemplateUuid
  }
  set trackingTemplateUuid(trackingTemplateUuid) {
    this._data.trackingTemplateUuid = trackingTemplateUuid
  }
  get multipleCabinets() {
    return this._data.multipleCabinets
  }
  set multipleCabinets(multipleCabinets) {
    this._data.multipleCabinets = multipleCabinets || false
  }
  get overseaWarehouseCode() { // 国外仓仓库代码
    return this._data.overseaWarehouseCode
  }
  set overseaWarehouseCode(overseaWarehouseCode) {
    this._data.overseaWarehouseCode = overseaWarehouseCode
  }
  get estDeliveryTime() { // 预计送达时间
    return this._data.estDeliveryTime
  }
  set estDeliveryTime(estDeliveryTime) {
    this._data.estDeliveryTime = estDeliveryTime
  }
  get actDeliveryTime() { // 实际送达时间
    return this._data.actDeliveryTime
  }
  set actDeliveryTime(actDeliveryTime) {
    this._data.actDeliveryTime = actDeliveryTime
  }
  get estWarehouseDeliveryTime() { // 预计进仓交货时间
    return this._data.estWarehouseDeliveryTime
  }
  set estWarehouseDeliveryTime(estWarehouseDeliveryTime) {
    this._data.estWarehouseDeliveryTime = estWarehouseDeliveryTime
  }
  get actWarehouseDeliveryTime() { // 实际进仓交货时间
    return this._data.actWarehouseDeliveryTime
  }
  set actWarehouseDeliveryTime(actWarehouseDeliveryTime) {
    this._data.actWarehouseDeliveryTime = actWarehouseDeliveryTime
  }
  get estGoodsDeliveryTime() { // 预计送货时间
    return this._data.estGoodsDeliveryTime
  }
  set estGoodsDeliveryTime(estGoodsDeliveryTime) {
    this._data.estGoodsDeliveryTime = estGoodsDeliveryTime
  }
  get actGoodsDeliveryTime() { // 实际送货时间
    return this._data.actGoodsDeliveryTime
  }
  set actGoodsDeliveryTime(actGoodsDeliveryTime) {
    this._data.actGoodsDeliveryTime = actGoodsDeliveryTime
  }
  get estReturnTime() { // 预计还空时间
    return this._data.estReturnTime
  }
  set estReturnTime(estReturnTime) {
    this._data.estReturnTime = estReturnTime
  }
  get actReturnTime() { // 实际还空时间
    return this._data.actReturnTime
  }
  set actReturnTime(actReturnTime) {
    this._data.actReturnTime = actReturnTime
  }
  get usCustomsClearanceList() { // 美国清关
    return this._data.usCustomsClearanceList
  }
  set usCustomsClearanceList(usCustomsClearanceList) {
    this._data.usCustomsClearanceList = usCustomsClearanceList
  }
  get cooperate() {
    return this._data.cooperate
  }
  set cooperate(cooperate) {
    this._data.cooperate = cooperate
  }
  get cooperateStatus() {
    return this._data.cooperateStatus
  }
  set cooperateStatus(cooperateStatus) {
    this._data.cooperateStatus = cooperateStatus
  }
  get cooperateProfitShare() {
    return this._data.cooperateProfitShare
  }
  set cooperateProfitShare(cooperateProfitShare) {
    this._data.cooperateProfitShare = cooperateProfitShare
  }
  get siteOpDepartment() {
    return this._data.siteOpDepartment
  }
  set siteOpDepartment(siteOpDepartment) {
    this._data.siteOpDepartment = siteOpDepartment || 0
  }
  get siteOP() {
    return this._data.siteOP
  }
  set siteOP(siteOP) {
    this._data.siteOP = siteOP || 0
  }
  get specialApprovalDate() { // 业务到期日、特批有效期至
    return this._data.specialApprovalDate
  }
  set specialApprovalDate(specialApprovalDate) {
    this._data.specialApprovalDate = specialApprovalDate
  }
  get customsDeclarationType() {
    return this._data.customsDeclarationType
  }
  set customsDeclarationType(customsDeclarationType) {
    this._data.customsDeclarationType = customsDeclarationType
  }
  get insure() { // 是否保险
    return this._data.insure
  }
  set insure(insure) {
    this._data.insure = insure
  }
  get businessLock() {
    return this._data.businessLock
  }
  set businessLock(businessLock) {
    this._data.businessLock = businessLock || false
  }
  get pigeonhole() { // 是否归档
    return this._data.pigeonhole
  }
  set pigeonhole(pigeonhole) {
    this._data.pigeonhole = pigeonhole || 0
  }
  get sentDestinationPortAgent() {
    return this._data.sentDestinationPortAgent
  }
  set sentDestinationPortAgent(sentDestinationPortAgent) {
    this._data.sentDestinationPortAgent = sentDestinationPortAgent || false
  }
  get sentDestinationPortAgentDate() {
    return this._data.sentDestinationPortAgentDate
  }
  set sentDestinationPortAgentDate(sentDestinationPortAgentDate) {
    this._data.sentDestinationPortAgentDate = sentDestinationPortAgentDate
  }
  get typeVirtualHbl() {
    return this._data.typeVirtualHbl
  }
  set typeVirtualHbl(typeVirtualHbl) {
    this._data.typeVirtualHbl = typeVirtualHbl || 0
  }
  get cooperatebranch() {
    return this._data.cooperatebranch
  }
  set cooperatebranch(cooperatebranch) {
    this._data.cooperatebranch = cooperatebranch
  }
  get saleProductCode() {
    return this._data.saleProductCode
  }
  set saleProductCode(saleProductCode) {
    this._data.saleProductCode = saleProductCode
  }
  get fullOrInside() {
    return this._data.fullOrInside
  }
  set fullOrInside(fullOrInside) {
    this._data.fullOrInside = fullOrInside || 0
  }
  get zyCreditWarning() {
    return this._data.zyCreditWarning
  }
  set zyCreditWarning(zyCreditWarning) {
    this._data.zyCreditWarning = zyCreditWarning
  }
  get transportSource() {
    return this._data.transportSource
  }
  set transportSource(transportSource) {
    this._data.transportSource = transportSource
  }
  get commitUser() {
    return this._data.commitUser
  }
  set commitUser(commitUser) {
    this._data.commitUser = commitUser
  }
  get automaticAllocation() {
    return this._data.automaticAllocation
  }
  set automaticAllocation(automaticAllocation) {
    this._data.automaticAllocation = typeof automaticAllocation === 'boolean' ? automaticAllocation : true
  }

  // 目的港清关
  get destPortCustomsClearance() {
    return this._data.destPortCustomsClearance
  }

  set destPortCustomsClearance(destPortCustomsClearance) {
    this._data.destPortCustomsClearance = destPortCustomsClearance
  }

  get advancePayment() {
    return this._data.advancePayment
  }
  set advancePayment(advancePayment) {
    this._data.advancePayment = advancePayment || false
  }
  get paymentTime() {
    return this._data.paymentTime
  }
  set paymentTime(paymentTime) {
    this._data.paymentTime = paymentTime
  }
  get customsDutyAmount() {
    return this._data.customsDutyAmount
  }
  set customsDutyAmount(customsDutyAmount) {
    this._data.customsDutyAmount = customsDutyAmount || 0
  }
  get vatAmount() {
    return this._data.vatAmount
  }
  set vatAmount(vatAmount) {
    this._data.vatAmount = vatAmount || 0
  }
  get taxRemarks() {
    return this._data.taxRemarks
  }
  set taxRemarks(taxRemarks) {
    this._data.taxRemarks = taxRemarks
  }
  get relatedJobLob() {
    return this._data.relatedJobLob
  }
  set relatedJobLob(relatedJobLob) {
    this._data.relatedJobLob = relatedJobLob
  }
  // 自定义岗位3
  get userDefinedRoleId3() {
    return this._data.userDefinedRoleId3
  }
  set userDefinedRoleId3(userDefinedRoleId3) {
    this._data.userDefinedRoleId3 = userDefinedRoleId3 || 0
  }
  get userDefinedRoleDept3() {
    return this._data.userDefinedRoleDept3
  }
  set userDefinedRoleDept3(userDefinedRoleDept3) {
    this._data.userDefinedRoleDept3 = userDefinedRoleDept3 || 0
  }
  get userDefinedRoleOffice3() {
    return this._data.userDefinedRoleOffice3
  }
  set userDefinedRoleOffice3(userDefinedRoleOffice3) {
    this._data.userDefinedRoleOffice3 = userDefinedRoleOffice3 || 0
  }
  // 自定义岗位4
  get userDefinedRoleId4() {
    return this._data.userDefinedRoleId4
  }
  set userDefinedRoleId4(userDefinedRoleId4) {
    this._data.userDefinedRoleId4 = userDefinedRoleId4 || 0
  }
  get userDefinedRoleDept4() {
    return this._data.userDefinedRoleDept4
  }
  set userDefinedRoleDept4(userDefinedRoleDept4) {
    this._data.userDefinedRoleDept4 = userDefinedRoleDept4 || 0
  }
  get userDefinedRoleOffice4() {
    return this._data.userDefinedRoleOffice4
  }
  set userDefinedRoleOffice4(userDefinedRoleOffice4) {
    this._data.userDefinedRoleOffice4 = userDefinedRoleOffice4 || 0
  }
  get exportControlledProduct() {
    return this._data.exportControlledProduct
  }
  set exportControlledProduct(exportControlledProduct) {
    this._data.exportControlledProduct = exportControlledProduct
  }
  get exportControlledLocked() {
    return this._data.exportControlledLocked
  }
  set exportControlledLocked(exportControlledLocked) {
    this._data.exportControlledLocked = exportControlledLocked
  }
  get userDefinedRoleId8() {
    return this._data.userDefinedRoleId8
  }
  set userDefinedRoleId8(userDefinedRoleId8) {
    this._data.userDefinedRoleId8 = userDefinedRoleId8
  }
  get cargoChineseNameWarning() {
    return this._data.cargoChineseNameWarning
  }
  set cargoChineseNameWarning(cargoChineseNameWarning) {
    this._data.cargoChineseNameWarning = cargoChineseNameWarning
  }
  get cargoEnglishNameWarning() {
    return this._data.cargoEnglishNameWarning
  }
  set cargoEnglishNameWarning(cargoEnglishNameWarning) {
    this._data.cargoEnglishNameWarning = cargoEnglishNameWarning
  }
  // 根据jobUuid获取费用详细信息列表
  static async getChargeDetails(job, reloadCharges = false) {
    let charges = job.charges
    // 参数修正
    if (job.uuid) {
      if (typeof charges !== 'object') {
        reloadCharges = true
      }
    } else {
      reloadCharges = false
      charges = charges || []
    }
    let params = null
    if (reloadCharges) {
      params = { jobUuid: job.uuid, reloadCharges: reloadCharges, customerId: job.customerId, bookingAgent: job.bookingAgent }
    } else {
      const chargeIds = []
      const accountIds = []
      for (const item of charges) {
        if (item.uuid) {
          chargeIds.push(item.uuid)
        }
        if (!accountIds.includes(item.accountId)) {
          accountIds.push(item.accountId)
        }
      }
      if (job.customerId && !accountIds.includes(job.customerId)) {
        accountIds.push(job.customerId)
      }
      if (job.bookingAgent && !accountIds.includes(job.bookingAgent)) {
        accountIds.push(job.bookingAgent)
      }
      params = { reloadCharges: reloadCharges, chargeIds: chargeIds, accountIds: accountIds, jobUuid: job.uuid }
    }
    const res = await getChargeDetails(params)
    if (!reloadCharges) {
      res.data.charges = charges
    }
    return res.data
  }
  // 空对象转换为null
  emptyObjectToNull() {
    const data = this._data
    data.seaEQ = data.seaEQ || null
    data.containerUsages = data.containerUsages || null
    data.containers = data.containers || null
    data.cargoDoc = data.cargoDoc || null
    data.lclSlaves = data.lclSlaves || null
    data.seaImportJob = data.seaImportJob || null
    data.jointSlavesMBL = data.jointSlavesMBL || null
    data.jointSlavesHBL = data.jointSlavesHBL || null
    data.jointSlavesHAWB2 = data.jointSlavesHAWB2 || null
    data.charges = data.charges || null
    data.bills = data.bills || null
    data.containerRef = data.containerRef || null
    data.manifestInfo = data.manifestInfo || null
    data.manifestInfos = data.manifestInfos || null
    data.warehouseInfo = data.warehouseInfo || null
    data.warehouseIn = data.warehouseIn || null
    data.jobWarehouseNos = data.jobWarehouseNos || null
    data.trucking = data.trucking || null
    data.truckingInfoPods = data.truckingInfoPods || null
    data.trackingInfo = data.trackingInfo || null
    data.customsInfo = data.customsInfo || null
    data.file = data.file || null
    data.surchargeTerms = data.surchargeTerms || null
    data.specialGoods = data.specialGoods || null
    data.jointMasterHBL = data.jointMasterHBL || null
    data.lclMaster = data.lclMaster || null
    data.backUpWarehouseInfo = data.backUpWarehouseInfo || null
  }
  // 加载Job的关联实体信息
  async loadJobRelated(params) {
    params.jobUuid = params.jobUuid || this._data.uuid
    if (!params.jobUuid) {
      return
    }
    // 是否需要载入
    let needLoad = false
    // 将已经加载过的属性的标识置为false
    for (const key in params) {
      if (key === 'jobUuid') {
        continue
      }
      if (key !== 'job' && params[key] && typeof this._data[key] === 'object') {
        params[key] = false
      }
      if (params[key]) {
        needLoad = true
      }
    }
    if (!needLoad) {
      return
    }
    await loadJobRelated(params).then(res => {
      const items = res.data
      if (items.job) {
        for (const key in items.job) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.job[key]
        }
      }
      for (const key in items) {
        if (key === 'job') {
          continue
        }
        if (key === 'lclSlaves') {
          items[key] = sortByMultiFieldAndOrder(items[key], { jobNo: 'asc', dateCreated: 'desc' })
        }
        this._data[key] = items[key] || null
      }
    })
  }
  async getSeaEQ() {
    const data = this._data
    if (typeof data.seaEQ !== 'object') {
      if (data.uuid) {
        data.seaEQ = await seaEQList({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.seaEQ = []
      }
    }
    return data.seaEQ
  }
  async getContainerUsages() {
    const data = this._data
    if (typeof data.containerUsages !== 'object') {
      if (data.uuid) {
        data.containerUsages = await containerUsagesByJobUuid({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.containerUsages = []
      }
    }
    return data.containerUsages
  }
  async getContainers() {
    const data = this._data
    if (typeof data.containers !== 'object') {
      if (data.uuid) {
        data.containers = await containerList({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.containers = []
      }
    }
    return data.containers
  }
  async getCargoDoc() {
    const data = this._data
    if (typeof data.cargoDoc !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'cargoDoc': true })
      } else {
        data.cargoDoc = []
      }
    }
    return data.cargoDoc
  }
  // 根据类型获取CargoDoc
  async getCargoDocByDocType(docType, isCreate) {
    const cargoDocs = await this.getCargoDoc()
    if (!cargoDocs) return null
    for (const cargoDoc of cargoDocs) {
      if (cargoDoc.docType === docType) {
        return cargoDoc
      }
    }
    if (isCreate) {
      return await SeaCargoDoc.createCargoDoc(this._data, docType)
    }
    return null
  }
  async getLclSlaves() {
    const data = this._data
    if (typeof data.lclSlaves !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ lclSlaves: true })
      } else {
        data.lclSlaves = []
      }
    }
    return data.lclSlaves
  }
  async getJointSlavesMBL() {
    const data = this._data
    if (typeof data.jointSlavesMBL !== 'object') {
      if (data.uuid) {
        data.jointSlavesMBL = await getJointSlavesMBL({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.jointSlavesMBL = []
      }
    }
    return data.jointSlavesMBL
  }
  async getJointSlavesHBL() {
    const data = this._data
    if (typeof data.jointSlavesHBL !== 'object') {
      if (data.uuid) {
        data.jointSlavesHBL = await getJointSlavesHBL({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.jointSlavesHBL = []
      }
    }
    return data.jointSlavesHBL
  }
  async getJointSlavesHAWB2() {
    const data = this._data
    if (typeof data.jointSlavesHAWB2 !== 'object') {
      if (data.uuid) {
        data.jointSlavesHAWB2 = await getJointSlavesHAWB2({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.jointSlavesHAWB2 = []
      }
    }
    return data.jointSlavesHAWB2
  }
  async getCharges() {
    const data = this._data
    if (typeof data.charges !== 'object') {
      if (data.uuid) {
        data.charges = await getChargeList(data.uuid).then(res => res.data)
      } else {
        data.charges = []
      }
    }
    return data.charges
  }
  async getAllSlaveChargeList() {
    const data = this._data
    if (data.uuid) {
      return await getAllSlaveChargeList(data.uuid).then(res => res.data)
    }
    return null
  }
  async getAllSlaveCargoDocList() {
    const data = this._data
    if (data.uuid) {
      return await getAllSlaveCargoDocList(data.uuid, data.lob).then(res => res.data)
    }
    return null
  }
  async getBills() {
    const data = this._data
    if (typeof data.bills !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'bills': true })
      } else {
        data.bills = []
      }
    }
    return data.bills
  }
  async getManifestInfos(loadManifestGoods = false, loadManifestVGMs = false) {
    const data = this._data
    if (typeof data.manifestInfos !== 'object') {
      if (data.uuid) {
        if (loadManifestGoods || loadManifestVGMs) {
          data.manifestInfos = await getManifestInfoDetailsByJobUuid({
            jobUuid: data.uuid,
            manifestGoods: loadManifestGoods,
            manifestVGMs: loadManifestVGMs
          }).then(res => res.data)
        } else {
          data.manifestInfos = await getManifestInfosByJobUuid({ jobUuid: data.uuid }).then(res => res.data)
        }
      } else {
        data.manifestInfos = []
      }
    }
    return data.manifestInfos
  }
  async getManifestInfo(loadManifestGoods = false, loadManifestVGMs = false) {
    const data = this._data
    if (typeof data.manifestInfo !== 'object') {
      const manifestInfos = await this.getManifestInfos(loadManifestGoods, loadManifestVGMs)
      data.manifestInfo = manifestInfos.length > 0 ? manifestInfos[0] : null
    }
    return data.manifestInfo
  }
  async getWarehouseInfo() {
    const data = this._data
    if (typeof data.warehouseInfo !== 'object') {
      if (data.uuid) {
        data.warehouseInfo = await warehouseInfoList({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.warehouseInfo = []
      }
    }
    return data.warehouseInfo
  }
  async getWarehouseInfo2() {
    const data = this._data
    if (data.uuid) {
      data.warehouseInfo = await warehouseInfoList({ jobUuid: data.uuid }).then(res => res.data)
    } else {
      data.warehouseInfo = []
    }
    return data.warehouseInfo
  }
  async getWarehouseIn() {
    const data = this._data
    if (typeof data.warehouseIn !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'warehouseIn': true })
      } else {
        data.warehouseIn = []
      }
    }
    return data.warehouseIn
  }
  async getTrucking() {
    const data = this._data
    if (typeof data.trucking !== 'object') {
      if (data.uuid) {
        data.trucking = await trucking({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.trucking = []
      }
    }
    return data.trucking
  }
  async getTruckingInfoPods() {
    const data = this._data
    if (typeof data.truckingInfoPods !== 'object') {
      if (data.uuid) {
        data.truckingInfoPods = await getTruckingInfoPodList({ anyStr: data.uuid }).then(res => res.data)
      } else {
        data.truckingInfoPods = []
      }
    }
    return data.truckingInfoPods
  }
  async getDischargingTrucking() {
    const data = this._data
    if (typeof data.dischargingTrucking !== 'object') {
      if (data.uuid) {
        data.dischargingTrucking = await getDischargingTruckingList({ jobUuid: data.uuid, masterFlag: data.masterFlag }).then(res => res.data)
      } else {
        data.dischargingTrucking = []
      }
    }
    return data.dischargingTrucking
  }
  async getTrackingInfo() {
    const data = this._data
    if (typeof data.trackingInfo !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'trackingInfo': true })
      } else {
        data.trackingInfo = []
      }
    }
    return data.trackingInfo
  }
  async getCustomsInfo() {
    const data = this._data
    if (typeof data.customsInfo !== 'object') {
      if (data.customsInfo) {
        await this.loadJobRelated({ 'customsInfo': true })
      } else {
        data.customsInfo = []
      }
    }
    return data.customsInfo
  }
  /**
   * 根据类型获取CargoDoc
   */
  async getCargoDocByType(type, create = false) {
    await this.getCargoDoc()
    if (this.cargoDoc.length === 0 && !create) {
      return null
    }
    for (const doc of this.cargoDoc) {
      if (doc.docType === type) {
        return doc
      }
    }
    if (!create) {
      return null
    }
    return await SeaCargoDoc.createCargoDoc(this, type)
  }
  // 自动装箱记录
  async loadPushHistoryLogs() {
    const data = this._data
    if (typeof data.pushHistoryLogs !== 'object') {
      if (data.uuid) {
        data.pushHistoryLogs = await loadAutoContainerLog({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.pushHistoryLogs = []
      }
    }
    return data.pushHistoryLogs
  }
  // PO信息
  async getPoList() {
    const data = this._data
    if (typeof data.poList !== 'object') {
      if (data.uuid) {
        data.poList = await poList({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.poList = []
      }
    }
    return data.poList
  }
  // 货物明细
  async getPoItems() {
    const data = this._data
    if (typeof data.poItems !== 'object') {
      if (data.uuid) {
        data.poItems = await poItems({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.poItems = []
      }
    }
    return data.poItems
  }
  // specialGoods
  async getSpecialGoods() {
    const data = this._data
    if (typeof data.specialGoods !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'specialGoods': true })
      } else {
        data.specialGoods = []
      }
    }
    return data.specialGoods
  }
  // 进仓编号列表
  async getJobWarehouseNos() {
    const data = this._data
    if (typeof data.jobWarehouseNos !== 'object') {
      if (data.uuid) {
        data.jobWarehouseNos = await getJobWarehouseNos({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.jobWarehouseNos = []
      }
    }
    return data.jobWarehouseNos
  }
  static async cargoDocSeaExportSearch(params) {
    return await cargoDocSeaExportSearch(params).then(res => res.data)
  }
  static async updateBusinessDate(jobKeys, businessDate) {
    return await updateBusinessDate(jobKeys, businessDate).then(res => res.data)
  }
  static async updateQWCActual(job) {
    return await updateQWCActual(job).then(res => res.data)
  }
  /**
   * 业务调整更新job
   * @param jobKeys
   * @param map
   * @returns {Promise<any>}
   */
  static async updateJob(jobKeys, map) {
    return await updateBusinessAdjustment({ jobKeys, map }).then(res => res.data)
  }
  /**
   * 取消财务审核
   * @param jobKeys
   * @param map
   * @returns {Promise<any>}
   */
  static async jobAccountVerifyRollback(jobKeys, branchId, location, rejectReason = '') {
    return await jobAccountVerifyRollback(jobKeys, branchId, location, rejectReason).then(res => res.data)
  }
  /**
   * 取消单个财务审核
   * @param jobKeys
   * @param map
   * @returns {Promise<any>}
   */
  static async jobSingleAccountVerifyRollback(jobKeys, branchId, location, rejectReason = '') {
    return await jobSingleAccountVerifyRollback(jobKeys, branchId, location, rejectReason).then(res => res.data)
  }
  // 允许改单
  static async updateChangeState(jobKeys, branchId) {
    return await updateChangeState(jobKeys, branchId).then(res => res.data)
  }
  // 取消结转
  static async jobClosingAccountRollbackHandler(jobKeys, location) {
    return await jobClosingAccountRollbackFunc(jobKeys, location).then(res => res.data)
  }
  /**
   * 根据主票，获取小票下面HBL的英文品名
   * @param {String} jobUuid
   */
  static async getSlavesHBLEnglishName(jobUuid) {
    return await getSlavesHBLEnglishName({ jobUuid }).then(res => res.data)
  }
  /**
   * 根据主票，获取小票下面HBL的唛头
   * @param {String} jobUuid
   */
  static async getSlavesHBLMark(jobUuid) {
    return await getSlavesHBLMark({ jobUuid }).then(res => res.data)
  }
  /**
   * 查询多个job装箱信息
   * @param {Array} uuids
   */
  static async getListJobContainerUsages(uuids) {
    return await getListJobContainerUsages({ uuids }).then(res => res.data)
  }
  /**
   * 获取未装箱的实际件数
   */
  static getUnboxedQuantityActual(quantity, containerUsages) {
    if (!containerUsages) return quantity
    for (const usage of containerUsages) {
      quantity -= usage.quantity
    }
    return quantity
  }
  /**
   * 获取未装箱的实际重量
   */
  static getUnboxedWeightActual(weight, containerUsages) {
    if (!containerUsages) return weight
    if (isNaN(weight)) { weight = 0.0 }
    for (const usage of containerUsages) {
      let usedWeight = usage.weight
      if (isNaN(usedWeight)) { usedWeight = 0.0 }
      weight -= usedWeight
    }
    return weight
  }
  /**
   * 获取未装箱的实际体积数
   */
  static getUnboxedCubageActual(cubage, containerUsages) {
    if (!containerUsages) return cubage
    if (isNaN(cubage)) { cubage = 0.0 }
    for (const usage of containerUsages) {
      let usedCubage = usage.cubage
      if (isNaN(usedCubage)) { usedCubage = 0.0 }
      cubage -= usedCubage
    }
    return cubage
  }
  /**
   * 获取未装箱的委托件数
   */
  static getUnboxedQuantityContract(quantity, containerUsages) {
    if (!containerUsages) return quantity
    for (const usage of containerUsages) {
      quantity -= usage.quantityContract
    }
    return quantity
  }
  /**
   * 获取未装箱的委托重量
   */
  static getUnboxedWeightContract(weight, containerUsages) {
    if (!containerUsages) return weight
    if (isNaN(weight)) { weight = 0.0 }
    for (const usage of containerUsages) {
      let usedWeight = usage.weightContract
      if (isNaN(usedWeight)) { usedWeight = 0.0 }
      weight -= usedWeight
    }
    return weight
  }
  /**
   * 获取未装箱的委托体积数
   */
  static getUnboxedCubageContract(cubage, containerUsages) {
    if (!containerUsages) return cubage
    if (isNaN(cubage)) { cubage = 0.0 }
    for (const usage of containerUsages) {
      let usedCubage = usage.cubageContract
      if (isNaN(usedCubage)) { usedCubage = 0.0 }
      cubage -= usedCubage
    }
    return cubage
  }
  /**
   * 获取未装箱的件数
   */
  getUnboxedQuantity() {
    let quantity = this.quantityActual
    if (!this.containerUsages) return quantity
    for (const usage of this.containerUsages) {
      quantity -= usage.quantity
    }
    return quantity
  }
  /**
   * 获取未装箱的重量
   */
  getUnboxedWeight() {
    let weight = this.weightActual
    if (!this.containerUsages) return weight
    if (isNaN(weight)) { weight = 0.0 }
    for (const usage of this.containerUsages) {
      let usedWeight = usage.weight
      if (isNaN(usedWeight)) { usedWeight = 0.0 }
      weight -= usedWeight
    }
    return weight
  }
  // /**
  //  * 获取未装箱的重量
  //  */
  // getUnboxedWeightMultiSoNoMode(unboxedPoItems, addGrossWeight) {
  //   let weight = 0
  //   if (unboxedPoItems && unboxedPoItems.length > 0) {
  //     const currentUnboxedPoItems = unboxedPoItems.filter(p => p.jobUuid === this.uuid)
  //     if (currentUnboxedPoItems && currentUnboxedPoItems.length > 0) {
  //       for (const poItem of currentUnboxedPoItems) {
  //         weight += poItem.grossWeight
  //       }
  //     }
  //   }
  //   if (addGrossWeight) {
  //     weight += addGrossWeight
  //   }
  //   weight = NumberUtils.formatNumber(weight, 3, true)
  //   return weight
  // }
  /**
   * 获取未装箱的体积数
   */
  getUnboxedCubage() {
    let cubage = this.cubageActual
    if (!this.containerUsages) return cubage
    if (isNaN(cubage)) { cubage = 0.0 }
    for (const usage of this.containerUsages) {
      let usedCubage = usage.cubage
      if (isNaN(usedCubage)) { usedCubage = 0.0 }
      cubage -= usedCubage
    }
    return cubage
  }
  // /**
  //  * 获取未装箱的体积数
  //  */
  // getUnboxedCubageMultiSoNoMode(unboxedPoItems, addCubage) {
  //   let cubage = 0
  //   if (unboxedPoItems && unboxedPoItems.length > 0) {
  //     const currentUnboxedPoItems = unboxedPoItems.filter(p => p.jobUuid === this.uuid)
  //     if (currentUnboxedPoItems && currentUnboxedPoItems.length > 0) {
  //       for (const poItem of currentUnboxedPoItems) {
  //         cubage += poItem.cubage
  //       }
  //     }
  //   }
  //   if (addCubage) {
  //     cubage += addCubage
  //   }
  //   cubage = NumberUtils.formatNumber(cubage, 3, true)
  //   return cubage
  // }
  // file
  async getFile() {
    const data = this._data
    if (typeof data.file !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'file': true })
      } else {
        data.file = []
      }
    }
    return data.file
  }
  copySCNotifyToDoc(doc) {
    if (this.mblOnly && (doc.docType === CargoDocConsts.MBL || doc.docType === CargoDocConsts.MAWB)) {
      new CargoDoc(doc).copyBasicShipper(this)
      new CargoDoc(doc).copyBasicConsignee(this)
      new CargoDoc(doc).copyBasicNotify(this)
    } else {
      if (doc.docType === CargoDocConsts.HBL || (this.lob === 'AE' && doc.docType === CargoDocConsts.HAWB)) {
        new CargoDoc(doc).copyBasicShipper(this)
        new CargoDoc(doc).copyBasicConsignee(this)
        new CargoDoc(doc).copyBasicNotify(this)
      }
    }
    if (doc instanceof SeaCargoDoc) {
      doc.alsoNotify = this.alsoNotify
    }
  }

  async getOverseaAgentPort(lob, port) {
    const data = this._data
    if (typeof data.overseaAgentPort !== 'object') {
      data.overseaAgentPort = await getOverseaAgentPort({ lob: lob, port: port }).then(res => res.data)
    }
    return data.overseaAgentPort
  }

  async checkShareCharge() {
    let hasSharedCharge = false
    const data = this._data
    if (!data.charges) {
      await this.getCharges()
    }
    if (data.charges && data.charges.length > 0) {
      for (const c of data.charges) {
        if (c.shared) {
          hasSharedCharge = true
          break
        }
      }
    }
    return hasSharedCharge
  }

  async getJointMasterMBL() {
    if (typeof this._data.jointMasterMBL !== 'object') {
      if (this._data.jointMasterMBLUuid) {
        const jointMasterMBL = await getJobByUuid(this._data.jointMasterMBLUuid).then(res => res.data)
        if (jointMasterMBL) this._data.jointMasterMBL = jointMasterMBL
      }
    }
    return this._data.jointMasterMBL
  }

  async getJointMasterHBL() {
    if (typeof this._data.jointMasterHBL !== 'object') {
      if (this._data.jointMasterHBLUuid) {
        const jointSlavesHBL = await getJobByUuid(this._data.jointMasterHBLUuid).then(res => res.data)
        if (jointSlavesHBL) this._data.jointMasterHBL = jointSlavesHBL
      }
    }
    return this._data.jointMasterHBL
  }

  async getBackUpWarehouseInfo() {
    const data = this._data
    if (typeof data.backUpWarehouseInfo !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'backUpWarehouseInfo': true })
      } else {
        data.backUpWarehouseInfo = []
      }
    }
    return data.backUpWarehouseInfo
  }

  async getUsCustomsClearanceList() {
    const data = this._data
    if (typeof data.usCustomsClearanceList !== 'object') {
      if (data.uuid) {
        await getUsCustomsClearanceDetailList({ jobUuid: data.uuid }).then(res => { data.usCustomsClearanceList = res.data || [] })
      } else {
        data.usCustomsClearanceList = []
      }
    }
    return data.usCustomsClearanceList
  }
  async getAirUld() {
    const data = this._data
    if (typeof data.airUld !== 'object') {
      if (data.uuid) {
        data.airUld = await airUldList({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.airUld = []
      }
    }
    return data.airUld
  }
  async getUnitLoadDeviceUsages() {
    const data = this._data
    if (typeof data.unitLoadDeviceUsages !== 'object') {
      if (data.uuid) {
        data.unitLoadDeviceUsages = await unitLoadDeviceUsagesByJobUuid({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.unitLoadDeviceUsages = []
      }
    }
    return data.unitLoadDeviceUsages
  }
  async getUnitLoadDevices() {
    const data = this._data
    if (typeof data.unitLoadDevices !== 'object') {
      if (data.uuid) {
        data.unitLoadDevices = await unitLoadDeviceList({ jobUuid: data.uuid }).then(res => res.data)
      } else {
        data.unitLoadDevices = []
      }
    }
    return data.unitLoadDevices
  }
  /**
   * 收货人
   */
  copyBasicConsignee(source, ignoreEmpty = false, syncCustomerShippingInfoBothBolAndBasicTab = false) {
    if (!StrUtils.isEmpty(source.consigneeLine1) ||
        !StrUtils.isEmpty(source.consigneeLine2) ||
        !StrUtils.isEmpty(source.consigneeLine3) ||
        !StrUtils.isEmpty(source.consigneeLine4) ||
        !StrUtils.isEmpty(source.consigneeLine5) ||
        !StrUtils.isEmpty(source.consigneeLine6) ||
        !StrUtils.isEmpty(source.consigneeLine7) || ignoreEmpty || syncCustomerShippingInfoBothBolAndBasicTab) {
      this.consigneeCode = source.consigneeCode
      this.consigneeLine1 = source.consigneeLine1
      this.consigneeLine2 = source.consigneeLine2
      this.consigneeLine3 = source.consigneeLine3
      this.consigneeLine4 = source.consigneeLine4
      this.consigneeLine5 = source.consigneeLine5
      this.consigneeLine6 = source.consigneeLine6
      this.consigneeLine7 = source.consigneeLine7
    }
    if (syncCustomerShippingInfoBothBolAndBasicTab) {
      this.consigneeId = source.consigneeId
    }
  }
  /**
   * 发货人
   */
  copyBasicShipper(source, ignoreEmpty = false, syncCustomerShippingInfoBothBolAndBasicTab = false) {
    if (!StrUtils.isEmpty(source.shipperLine1) ||
        !StrUtils.isEmpty(source.shipperLine2) ||
        !StrUtils.isEmpty(source.shipperLine3) ||
        !StrUtils.isEmpty(source.shipperLine4) ||
        !StrUtils.isEmpty(source.shipperLine5) ||
        !StrUtils.isEmpty(source.shipperLine6) ||
        !StrUtils.isEmpty(source.shipperLine7) || ignoreEmpty || syncCustomerShippingInfoBothBolAndBasicTab) {
      this.shipperCode = source.shipperCode
      this.shipperLine1 = source.shipperLine1
      this.shipperLine2 = source.shipperLine2
      this.shipperLine3 = source.shipperLine3
      this.shipperLine4 = source.shipperLine4
      this.shipperLine5 = source.shipperLine5
      this.shipperLine6 = source.shipperLine6
      this.shipperLine7 = source.shipperLine7
    }
    if (syncCustomerShippingInfoBothBolAndBasicTab) {
      this.shipperId = source.shipperId
    }
  }
  /**
   * 通知人
   */
  copyBasicNotify(source, ignoreEmpty = false, syncCustomerShippingInfoBothBolAndBasicTab = false) {
    if (!StrUtils.isEmpty(source.notifyLine1) ||
        !StrUtils.isEmpty(source.notifyLine2) ||
        !StrUtils.isEmpty(source.notifyLine3) ||
        !StrUtils.isEmpty(source.notifyLine4) ||
        !StrUtils.isEmpty(source.notifyLine5) ||
        !StrUtils.isEmpty(source.notifyLine6) ||
        !StrUtils.isEmpty(source.notifyLine7) || ignoreEmpty || syncCustomerShippingInfoBothBolAndBasicTab) {
      this.notifyCode = source.notifyCode
      this.notifyLine1 = source.notifyLine1
      this.notifyLine2 = source.notifyLine2
      this.notifyLine3 = source.notifyLine3
      this.notifyLine4 = source.notifyLine4
      this.notifyLine5 = source.notifyLine5
      this.notifyLine6 = source.notifyLine6
      this.notifyLine7 = source.notifyLine7
    }
    if (syncCustomerShippingInfoBothBolAndBasicTab) {
      this.notifyId = source.notifyId
    }
  }
  syncJobSftToDoc(doc, ignoreEmpty, syncCustomerShippingInfoBothBolAndBasicTab) {
    new CargoDoc(doc).copyBasicShipper(this, ignoreEmpty, syncCustomerShippingInfoBothBolAndBasicTab)
    new CargoDoc(doc).copyBasicConsignee(this, ignoreEmpty, syncCustomerShippingInfoBothBolAndBasicTab)
    new CargoDoc(doc).copyBasicNotify(this, ignoreEmpty, syncCustomerShippingInfoBothBolAndBasicTab)
  }
}
